import productForm from "./tickets-form";
import availability from "./tickets-form/availability";
import PerfectScrollbar from "perfect-scrollbar";

$(() => {
  const saveCheckoutForm = () => {
    $.ajax({
      url: "/quote/storeCheckoutForm",
      method: "post",
      data: $(".js-validate-checkout input").serialize()
    });
  };
  $(document).on("focusout", ".js-validate-checkout input", function(e) {
    saveCheckoutForm();
  });
  $(".js-book-now").on("click", function(e) {
    e.preventDefault();
    let $bookBtn = $(this);
    let quoteItem = availability.availabilityResponse;
    quoteItem.ageBandPrices = productForm.getPricesResponse()[quoteItem.productId];

    $.ajax({
      method: "post",
      url:
        "/quote/storeItem/" + quoteItem.productId + "/" + quoteItem.variationId,
      dataType: "json",
      contentType: "application/json",
      data: JSON.stringify(quoteItem),
      complete: function() {
        $(".js-booking-questions").validate({
          errorElement: "div",
          errorClass: "label__error",
          focusInvalid: true,

          highlight: function(element, errorClass) {
            const { form, id, name } = element;
            const errorBlock = $(form).find(`div[for="${id ? id : name}"]`);

            $(element)
              .closest(".js-label")
              .addClass("has-error");
            $(element)
              .closest(".js-field-dropdown__label")
              .addClass("has-error");

            $(errorBlock).addClass(errorClass);
          },

          unhighlight: function(element, errorClass) {
            const { form, id, name } = element;
            if (!id && !name) return;
            const errorBlock = $(form).find(`div[for="${id ? id : name}"]`);

            $(element)
              .closest(".js-label")
              .removeClass("has-error");

            $(element)
              .closest(".js-field-dropdown__label")
              .removeClass("has-error");

            $(errorBlock).removeClass(errorClass);
          },

          rules: {
            hotel_pickup_option: {
              required: true
            }
          },

          messages: {
            hotel_pickup_option: {
              required: "This field is required."
            }
          }
        });

        const scrollbar = $(".js-scrollbar").map(
          (i, item) => new PerfectScrollbar(item)
        );

        const fields = $(".modal-window__field .js-label__field");

        for (let i = 0; i < fields.length; i++) {
          $(fields[i]).rules("add", {
            minlength: 3
          });
        }
      }
    })
      .done(response => {
        if (response.status === "error") {
          let $errorBox = $(".js-information__error-box");

          $errorBox.text(response.message);
          $errorBox.removeClass("hidden");
          $errorBox.closest(".js-field-dropdown__label").addClass("has-error");
          $(".js-book-now").attr("disabled", true);

          return;
        }

        if (response.status === "success") {
          if ($bookBtn.data("target")) {
            return window.location.href = $bookBtn.data("target");
          }
          return window.location.reload();
        }
        $(".js-booking-questions-modal").fadeIn("easing");
        $("body").addClass("static");

        const scrollbar = $(".js-scrollbar").map(
          (i, item) => new PerfectScrollbar(item)
        );

        return $(".js-booking-questions-content").html(response.form);
      })
      .fail((e, rr, ors) => {});
  });
  $(document).on("submit", ".js-booking-questions", function(e) {
    e.preventDefault();

    var form = $(this);
    $.ajax({
      method: "post",
      url: form.attr("action"),
      data: form.serialize()
    })
      .done(response => {
        if (
          typeof response.errors == "undefined" ||
          response.errors.length === 0
        ) {
          let $bookBtn = $(".js-book-now");
          if ($bookBtn.data("target")) {
            return window.location.replace($bookBtn.data("target"));
          }
          window.location.reload();
        }
      })
      .fail((e, rr, ors) => {});
  });
  $(document)
    .off("input")
    .on("input", ".js-travellers-0 input", function() {
      let leftForms = $(".js-travellers-1"),
        bandId = $(this).data("band-id"),
        value = $(this).val();
      let slicedValue = value ? value.slice(0, -1) : "";
      leftForms.each(function(i, el) {
        let inputToAutocomplete = $(this).find(
          'input[data-band-id="' + bandId + '"]'
        );
        let inputToAutocompleteValue = inputToAutocomplete.val();
        let inputToAutocompleteSlicedValue = inputToAutocompleteValue
          ? inputToAutocompleteValue.slice(0, -1)
          : "";
        if (
          inputToAutocomplete.val() == "" ||
          inputToAutocompleteValue == slicedValue ||
          inputToAutocompleteSlicedValue == value
        ) {
          inputToAutocomplete.val(value);
        }
      });
    });
  $(".js-destroy-cart-item").on("click", function(e) {
    e.preventDefault();
    let url = $(this).data("href");
    $.ajax({
      method: "post",
      url: url,
      contentType: "application/json"
    })
      .done(response => {
        window.location.replace(window.location.href);
      })
      .fail((e, rr, ors) => {});
  });
  $(document).on("click", ".js-close-window-modal", e => {
    if (!$(e.target).hasClass("js-close-window-modal")) return;

    $("body").removeClass("static");
    $(".js-booking-questions-modal").fadeOut("easing");
  });
});



// WEBPACK FOOTER //
// ./resources/assets/js/components/product/book.js